import React, { Fragment } from "react";
import { Button, Table } from "react-bootstrap";

export const WeekHomeForm = ({ weeks, handleDetail }) => {
  return (
    <Fragment>
      <Table striped>
        <thead>
          <tr>
            <th>수업</th>
            <th>주차</th>
            <th>상태</th>
            <th>인증코드</th>
            <th>팀명들</th>
            <th style={{ visibility: "hidden" }}> </th>
          </tr>
        </thead>
        <tbody>
          {weeks ? (
            weeks.map((it, index) => {
              return (
                <tr key={index}>
                  <td>{`${it.course.courseNumber}-${it.course.courseName}`}</td>
                  <td>{it.week}</td>
                  <td>{it.state}</td>
                  <td>{it.auth.code}</td>
                  <td>{it.teams.map((it) => it.name).join(", ")}</td>
                  <td>
                    <Button size="sm" onClick={handleDetail} value={it._id}>
                      상세
                    </Button>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td>데이타가 없습니다.</td>
            </tr>
          )}
        </tbody>
      </Table>
    </Fragment>
  );
};
